<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/slag/collection/record/page" getKey="rows" :columns="columns" @selectionChange="selectionChange">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('shoujipicihao')">
            <el-input v-model="yt.conditions.batchNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('liaochebianhao')">
            <el-input v-model="yt.conditions.containerNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('wuliaomingcheng')">
            <yi_data_select type="material2" :ids.sync="yt.conditions.materialId"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('liuchengzhuangtai')">
            <yi_dictionary_select type="SOUP_PROCESS_STATUS" :ids.sync="yt.conditions.processStatus"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('chengzhongzhuangtai')">
            <yi_dictionary_select type="SOUP_WEIGHING_STATUS" :ids.sync="yt.conditions.weighingStatus"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('suoshuchejian')">
            <yi_data_select type="organization" :ids.sync="yt.conditions.orgId"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('shoucizhuangcheshijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.firstCollectTimeStart" :end.sync="yt.conditions.firstCollectTimeEnd"></yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('zuihouzhuangcheshijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.lastCollectTimeStart" :end.sync="yt.conditions.lastCollectTimeEnd"></yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('chengzhongshijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.weighingTimeStart" :end.sync="yt.conditions.weighingTimeEnd"></yi_time_input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button :isAutoExpand="true"></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button v-if="utils.checkPower('web_cast_management_slag_bag_create')" size="mini" type="primary" @click="yt.showEditDialog('xinzeng', null, 'w2', beforeShowInsertDialog)">
          {{ $t('xinzeng') }}
        </el-button>
        <!--导出标签-->
        <el-button size="mini" type="primary" v-if="utils.checkPower('web_cast_management_slag_bag_export_label')" :disabled="checkDisabled" @click="exportLabel" :loading="exportLabelLoading"  v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '渣包回收-导出标签' } }">
          {{ $t('daochubiaoqian') }}
        </el-button>
        <!--回传ERP-->
        <el-button size="mini" type="primary"  v-if="utils.checkPower('web_cast_management_slag_bag_send_to_erp')" :disabled="checkDisabled" @click="sendToERP" :loading="sendToERPLoading"  v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '渣包回收-回传ERP' } }">
          {{ $t('huichuanERP') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')" :loading="exportLoading" @click="exportExcel()" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '出汤记录-导出' } }"></el-button>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"> </el-button>
      </template>
      <!-- <template #zhongliang(KG)="scope">
        {{ (scope.row.weight != null ? (scope.row.weight / 1000).toFixed(1) : '') % 1 == 0 ? (scope.row.weight != null ? (scope.row.weight / 1000).toFixed(0) : '') : scope.row.weight != null ? (scope.row.weight / 1000).toFixed(1) : '' }}
      </template> -->
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('bianji', scope.row, 'w2', beforeShowEditDialog)" v-if="utils.checkPower('web_cast_management_slag_bag_update')">{{ $t('bianji') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('chengzhongjilu', scope.row, '80%')">{{ $t('chengzhongjilu') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" class="font-color-danger" :loading="yt.editObj.loading" @click="yt.remove(scope.row, '/web/slag/collection/record/delete')" v-if="utils.checkPower('web_cast_management_slag_bag_delete')">{{ $t('shanchu') }} </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <template v-if="yt.editObj.action === 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('liaoche')" required>
            <yi_data_select type="tool" :ids.sync="yt.editObj.containerId"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('shoucizhuangcheshijian')">
            <yi_time_input type="datetime" :time.sync="yt.editObj.firstCollectTime"></yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('wuliaomingcheng')" required>
            <yi_data_select type="material2" :ids.sync="yt.editObj.materialId"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('zuihouzhuangcheshijian')">
            <yi_time_input type="datetime" :time.sync="yt.editObj.lastCollectTime"></yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('liuchengzhuangtai')" required>
            <yi_dictionary_select type="SOUP_PROCESS_STATUS" :ids.sync="yt.editObj.processStatus"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('xiecheshijian')" required>
            <yi_time_input type="datetime" :time.sync="yt.editObj.removeTime"></yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('chengzhongzhuangtai')">
            <yi_dictionary_select type="SOUP_WEIGHING_STATUS" :ids.sync="yt.editObj.weighingStatus"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('chengzhongshijian')">
            <yi_time_input type="datetime" :time.sync="yt.editObj.weighingTime"></yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('jingzhong')">
            <el-input-number v-model="yt.editObj.netWeight" :precision="4" :step="0.1" :min="0"></el-input-number>
          </el-form-item>
          <el-form-item :label="$t('jingzhongdanwei')">
            <yi_dictionary_select type="UNIT_CONVERSION_TYPE" :ids.sync="yt.editObj.weightUnit"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('suoshuchejian')" required>
            <yi_data_select type="organization" :ids.sync="yt.editObj.orgId"> </yi_data_select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button v-if="utils.checkPower('web_cast_management_slag_bag_create')" size="mini" @click="yt.req('POST', '/web/slag/collection/record/create', beforeAdd)" :loading="yt.editObj.loading" type="primary">{{ $t('baocun') }} </el-button>
        </span>
      </template>
      <template v-if="yt.editObj.action === 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('liaoche')" required>
            <yi_data_select type="tool" :ids.sync="yt.editObj.containerId"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('shoucizhuangcheshijian')">
            <yi_time_input type="datetime" :time.sync="yt.editObj.firstCollectTime"></yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('wuliaomingcheng')" required>
            <yi_data_select type="material2" :ids.sync="yt.editObj.materialId"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('zuihouzhuangcheshijian')">
            <yi_time_input type="datetime" :time.sync="yt.editObj.lastCollectTime"></yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('liuchengzhuangtai')" required>
            <yi_dictionary_select type="SOUP_PROCESS_STATUS" :ids.sync="yt.editObj.processStatus"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('xiecheshijian')" required>
            <yi_time_input type="datetime" :time.sync="yt.editObj.removeTime"></yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('chengzhongzhuangtai')">
            <yi_dictionary_select type="SOUP_WEIGHING_STATUS" :ids.sync="yt.editObj.weighingStatus"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('chengzhongshijian')">
            <yi_time_input type="datetime" :time.sync="yt.editObj.weighingTime"></yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('jingzhong')">
            <el-input-number v-model="yt.editObj.netWeight" :precision="4" :step="0.1" :min="0"></el-input-number>
          </el-form-item>
          <el-form-item :label="$t('jingzhongdanwei')">
            <yi_dictionary_select type="UNIT_CONVERSION_TYPE" :ids.sync="yt.editObj.weightUnit"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('suoshuchejian')" required>
            <yi_data_select type="organization" :ids.sync="yt.editObj.orgId"> </yi_data_select>
          </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
          <div style="display: flex;flex-wrap: nowrap;justify-content: space-between;">
            <div style="color:red;margin-left: 20px;">{{ tip }}</div>
            <div>
              <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
              <el-button v-if="utils.checkPower('web_cast_management_slag_bag_update')" size="mini" @click="yt.req('POST', '/web/slag/collection/record/update')" :disabled="defaultDisabled" :loading="yt.editObj.loading" type="primary">{{ $t('baocun') }} </el-button>
            </div>
          </div>
        </span>
      </template>
      <template v-if="yt.editObj.action === 'chengzhongjilu'">
        <div class="dialog-scroller">
          <weighing-record :soupRecordId="yt.editObj.id"></weighing-record>
        </div>
        <!-- <span slot="footer" class="dialog-footer">
          <el-button type="default" size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button type="primary" size="mini" @click="yt.isShowEditDialog = false">{{ $t('baocun') }}</el-button>
        </span> -->
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import weighingRecord from './weighing_record.vue';
import XLSX from 'xlsx';
export default {
  name: 'web_cast_management_slag_bag_recycling_list',
  components: {
    weighingRecord
  },
  data() {
    return {
      defaultDisabled: false,
      exportLoading: false,
      tip: '',
      ids: null,
      exportLabelLoading: false,
      sendToERPLoading: false,
      checkDisabled: true,
      columns: [
        {
          label: 'xuanze',
          type: 'selection'
        },
        {
          label: 'shoujipicihao',
          prop: 'batchNo',
          width: 150
        },
        {
          label: 'liaochebianhao',
          prop: 'container.toolNo',
          width: 150
        },
        {
          label: 'wuliaobianma',
          prop: 'material.code',
          width: 150
        },
        {
          label: 'wuliaomingcheng',
          prop: 'material.name',
          width: 150
        },
        {
          label: 'wuliaoguige',
          prop: 'material.spec',
          width: 150
        },
        {
          label: 'shoucizhuangcheshijian',
          prop: 'firstCollectTime',
          type: 'time',
          format: 'YYYY-MM-DD HH:mm',
          width: 150
        },
        {
          label: 'zuihouzhuangcheshijian',
          prop: 'lastCollectTime',
          type: 'time',
          format: 'YYYY-MM-DD HH:mm',
          width: 150
        },
        {
          label: 'chengzhongshijian',
          prop: 'weighingTime',
          type: 'time',
          format: 'YYYY-MM-DD HH:mm',
          width: 150
        },
        {
          label: 'liuchengzhuangtai',
          prop: 'processStatus',
          type: 'dictionary_tag',
          key: 'SOUP_PROCESS_STATUS',
          width: 150
        },
        {
          label: 'chengzhongzhuangtai',
          prop: 'weighingStatus',
          type: 'dictionary_tag',
          key: 'SLAG_WEIGHING_STATUS',
          width: 150
        },
        {
          label: 'huichuanerpzhuagntai',
          prop: 'erpSendStatus',
          type: 'dictionary_tag',
          key: 'SOUP_ERP_SEND_STATUS',
          width: 150
        },
        {
          label: 'jingzhong',
          prop: 'netWeight'
          //   width: 150
        },
        {
          label: 'jingzhongdanwei',
          prop: 'weightUnit',
          type: 'dictionary',
          key: 'UNIT_CONVERSION_TYPE',
          width: 150
        },
        {
          label: 'suoshuchejian',
          prop: 'org.name',
          width: 150
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 250,
          fixed: 'right'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.get(1);
    }, 300);
  },
  methods: {
    // 生成并导出excel
    exportExcel() {
      this.exportLoading = true;
      const data = this.yt.list || [];
      // 筛选出表头和prop
      const columns = this.columns.filter(c => c.type !== 'slot');
      let tableFirst = columns.map(column => this.$t(column.label));
      // 顺序封装表格数据
      let tableArr = [];
      tableArr.push(tableFirst);
      for (let i = 0; i < data.length; i++) {
        let dataArr = [];
        for (let j = 0; j < columns.length; j++) {
          const column = columns[j];
          const value = this.utils.getObjValueByLevelString(data[i], column.prop);
          const v = this.formatValue(column, value);
          dataArr.push(v);
        }
        tableArr.push(dataArr);
      }
      const worksheet = XLSX.utils.aoa_to_sheet(tableArr);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
      XLSX.writeFile(workbook, `渣包回收_导出_${this.dayjs().format('YYYY-MM-DD_HH-mm-ss')}.xlsx`);
      this.exportLoading = false;
    },
    // 导出Excel时格式化值
    formatValue(column, value) {
      if (value == null) {
        return '';
      }
      switch (column.type) {
        case 'time':
          return this.dayjs(value).format('YYYY-MM-DD HH:mm:ss');
        case 'dictionary_tag':
          return this.$t(this.$store.state.dictJson[column.key][value]);
        case 'dictionary':
          return this.$t(this.$store.state.dictJson[column.key][value]);
        default:
          return value;
      }
    },
    beforeAdd(params, url) {
      params.operatingInterface = 0;
      return params;
    },
    // 新增之前处理数据
    beforeShowInsertDialog(row) {
      row.firstCollectTime = this.dayjs().valueOf();
      row.lastCollectTime = this.dayjs().valueOf();
      row.removeTime = this.dayjs().valueOf();
      row.weighingTime = this.dayjs().valueOf();
      row.processStatus = '2';
      row.pouringStatus = '1';
      row.weighingStatus = '2';
      return row;
    },
    // 编辑之前处理数据
    beforeShowEditDialog(row) {
      this.getRecordPage(row.id);
      return row;
    },
    getRecordPage(row) {
      let params = {
        sourceDocumentId: row,
        businessType: 18
      };
      this.http
        .get('/web/weighing/record/page', {
          params: params
        })
        .then(res => {
          if (res.data.rows.length > 0) {
            //编辑存在关联的流程记录，保存按钮禁用
            this.defaultDisabled = true;
            this.tip = this.$t('cunzaiguanliandeliuchengjiluwufaxiugai');
          } else {
            this.defaultDisabled = false;
            this.tip = '';
          }
        });
    },

    selectionChange(items) {
      this.ids = items.map(item => {
        return item.id;
      });
      if (this.ids.length > 0) {
        this.checkDisabled = false;
      } else {
        this.checkDisabled = true;
      }
    },
    exportLabel() {
      this.exportLabelLoading = true;
      let params = { ids: this.ids };
      this.http.get("/web/slag/collection/record/exportLabel", { params: params } )
        .then(response => {
          let fileId = response.data;
          return this.http.get('/web/customer/files/download?id=' + fileId)
            .then(fileRes => {
              let baseUrl = fileRes.data;

              if (baseUrl) {
                window.open(baseUrl);
              } else {
                this.utils.errorMessage(this.$t('wenjianlianjieweikong'));
              }
              this.exportLabelLoading = false;
            }).catch(error => {
              this.$message.error(error)
            })
        }).catch(error => {
        this.$message.error(error)
        }).finally(() => {
          this.exportLabelLoading = false;
        });

    },
    // 回传ERP
    sendToERP() {
      this.sendToERPLoading = true;
      let params = { ids: this.ids };
      this.http.post("/custom/slag/collection/record/sendToERP", params )
        .then(response => {
          this.utils.successMessage(this.$t(response.msg));
          this.sendToERPLoading = false;
        }).catch(error => {
        this.$message.error(error)
      }).finally(() => {
        this.sendToERPLoading = false;
        this.yt.get();
      });
    },
  }
};
</script>
